export type WeekdaySelectorValue = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export interface WeekdaySelectorDay {
    caption: string;
    state: boolean;
    value: WeekdaySelectorValue;
}

export type WeekdaySelectorCaptions = Record<WeekdaySelectorValue, string>;

export const DEFAULT_SELECTED_WEEKDAY_VALUES: WeekdaySelectorValue[] = [1, 2, 3, 4, 5];
export const WEEKDAY_SELECTOR_VALUES: WeekdaySelectorValue[] = [1, 2, 3, 4, 5, 6, 7];

export const WEEKDAY_TRANSLATION_KEYS: Record<WeekdaySelectorValue, string> = {
    1: 'coWeekdaySelector.weekdays.mondayShort',
    2: 'coWeekdaySelector.weekdays.tuesdayShort',
    3: 'coWeekdaySelector.weekdays.wednesdayShort',
    4: 'coWeekdaySelector.weekdays.thursdayShort',
    5: 'coWeekdaySelector.weekdays.fridayShort',
    6: 'coWeekdaySelector.weekdays.saturdayShort',
    7: 'coWeekdaySelector.weekdays.sundayShort',
};

export function createWeekdaySelectorValue(
    captions: WeekdaySelectorCaptions,
    selectedValues: WeekdaySelectorValue[] = DEFAULT_SELECTED_WEEKDAY_VALUES
): WeekdaySelectorDay[] {
    return WEEKDAY_SELECTOR_VALUES.map((value) => ({
        caption: captions[value],
        state: selectedValues.includes(value),
        value,
    }));
}

export function normalizeWeekdaySelectorValue(
    weekdays: WeekdaySelectorDay[] = [],
    captions: WeekdaySelectorCaptions,
    fallbackSelectedValues: WeekdaySelectorValue[] = DEFAULT_SELECTED_WEEKDAY_VALUES
): WeekdaySelectorDay[] {
    if (!Array.isArray(weekdays) || weekdays.length === 0) {
        return createWeekdaySelectorValue(captions, fallbackSelectedValues);
    }

    const weekdayStateMap = {} as Partial<Record<WeekdaySelectorValue, boolean>>;

    weekdays.forEach((weekday) => {
        if (weekday?.value) {
            weekdayStateMap[weekday.value] = Boolean(weekday.state);
        }
    });

    return createWeekdaySelectorValue(captions, fallbackSelectedValues).map((weekday) => ({
        ...weekday,
        state: weekdayStateMap[weekday.value] ?? weekday.state,
    }));
}
